const getOneHourAfter = (dateTime: any) => {
  const d = new Date(dateTime);
  const oneHourAfter = d.setHours(d.getHours() + 1);
  return new Date(oneHourAfter);
};

export default getOneHourAfter;
